import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQSection = () => {
  const { t } = useTranslation();
  const items = t('faq.items', { returnObjects: true }) || [];
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-24 bg-neutral-950" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold-50 border border-gold-100 rounded-full mb-6">
            <HelpCircle className="w-4 h-4 text-gold-500" />
            <span className="text-gold-600 text-sm font-medium">{t('faq.badge')}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {t('faq.title')}{' '}
            <span className="text-gold-500">{t('faq.title_highlight')}</span>
          </h2>
        </div>

        {/* FAQ items */}
        <div className="space-y-4">
          {(Array.isArray(items) ? items : []).map((item, i) => (
            <div
              key={i}
              className={`rounded-2xl border transition-all duration-300 ${
                openIndex === i
                  ? 'border-gold-500/30 bg-gold-500/5 shadow-sm'
                  : 'border-gold-900/20 bg-white/5 hover:border-gold-900/40'
              }`}
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                className="flex items-center justify-between w-full text-left p-6"
                data-testid={`faq-toggle-${i}`}
              >
                <span className={`font-semibold pr-4 transition-colors ${
                  openIndex === i ? 'text-gold-400' : 'text-white'
                }`}>
                  {item.q}
                </span>
                <ChevronDown className={`w-5 h-5 shrink-0 transition-all duration-300 ${
                  openIndex === i ? 'rotate-180 text-gold-500' : 'text-white/40'
                }`} />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-6 pb-6 text-white/60 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
